module.exports = __webpack_public_path__ + "staticcomp/img/content_1.dec30d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/content_1.jpg
// module id = S6g8
// module chunks = 39